import React from "react";
import PropTypes from "prop-types";
import Form from "../Form/form";
import {controlPropTypes} from "../formhelpers";

class Column extends React.Component {
    render() {
        const {
            descriptor
        } = this.props;
        const selector = `control-container-${descriptor.key}`;
        return (
            <div
                id={descriptor.id}
                className={`${selector} control-layout-column`}
            >
                <Form {...this.props} />
            </div>
        );
    }
}

Column.defaultProps = {
    descriptor: {},
    controlOnly: true,
    placeholder: true
};

Column.propTypes = {
    ...controlPropTypes(null, false, true),
    propsResolver: PropTypes.func.isRequired,
    onCommitChange: PropTypes.func, // not required
};

export default Column;



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/Layout/column.js